<section class="min-h-screen px-3 pb-8 pt-5 sm:px-5 lg:px-8">
  <div class="mx-auto max-w-[1600px]">

    <!-- Page header -->
    <!-- <div class="mb-5 flex items-center gap-3">
      <div class="flex items-center justify-center rounded-full bg-[#FFD4E0] text-[#D31148]" style="min-height: 40px; min-width: 40px;">
        <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
      </div>
      <div>
        <h1 class="text-xl font-bold text-gray-900">All</h1>
        <p class="text-sm text-gray-500">Posts, blogs and events — all in one place, newest first</p>
      </div>
    </div> -->

    <!-- On-page search -->
    <!-- <div class="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center">
      <div class="relative flex-1">
        <input type="text" [(ngModel)]="searchInput" (keydown.enter)="submitSearch()"
          placeholder="Search by title or #hashtag…"
          class="w-full rounded-xl border border-[#e8e8e8] bg-[#fafafa] px-4 py-2.5 pr-10 text-sm text-gray-700 placeholder-gray-400 outline-none focus:border-[#D31148] focus:ring-1 focus:ring-[#D31148] transition-colors" />
        <button *ngIf="searchInput" type="button" (click)="clearSearch()"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#D31148] transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <svg *ngIf="!searchInput" width="18" height="18" viewBox="0 0 24 24" fill="none"
          class="absolute text-gray-400 right-3 top-1/2 -translate-y-1/2 pointer-events-none">
          <path d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <button type="button" (click)="submitSearch()"
        class="rounded-xl bg-[#D31148] px-6 py-2.5 text-sm font-semibold text-white hover:bg-[#b80e3d] transition-colors whitespace-nowrap">
        Search
      </button>
    </div> -->

    <!-- Active filter chip -->
    <div *ngIf="hasActiveFilter" class="mb-4 flex items-center gap-2">
      <span class="text-xs font-medium text-gray-500">Showing results for</span>
      <span class="inline-flex items-center gap-1.5 rounded-full bg-[#FFD4E0] px-3 py-1 text-sm font-semibold text-[#D31148]">
        {{ activeHashtag ? '#' + activeHashtag : activeQuery }}
        <button type="button" (click)="clearSearch()" class="hover:opacity-70">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"
            stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </span>
    </div>

    <!-- Section 1: matched profile(s) — shown above the normal results when
         the search term also matches a person's display name/username -->
    <div *ngIf="profiles.length > 0" class="mb-6">
      <p class="mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wide">Profile</p>
      <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        <button *ngFor="let profile of profiles" type="button" (click)="goToProfile(profile)"
          class="flex items-center gap-3 rounded-2xl border border-[#f0f0f0] bg-white p-4 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md">
          <img [src]="profile.profileImage?.urlMedium ?? profile.profileImage?.urlSmall ?? avatarFallback(profile.displayName)"
            [alt]="profile.displayName" class="h-12 w-12 flex-shrink-0 rounded-full object-cover" />
          <span class="min-w-0 flex-1">
            <span class="block truncate text-sm font-semibold text-gray-900">{{ profile.displayName }}</span>
            <span class="block truncate text-xs text-gray-400">&#64;{{ profile.userName }}</span>
          </span>
          <span class="flex-shrink-0 rounded-full bg-[#FFD4E0] px-3 py-1.5 text-xs font-semibold text-[#D31148]">
            View profile
          </span>
        </button>
      </div>
    </div>

    <!-- Section 2: normal mixed feed — posts/blogs/events cards interleave by
         createdAt via the `order` style each card sets (see child components) -->
    <p *ngIf="profiles.length > 0 && allItems.length > 0" class="mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wide">
      Posts, blogs &amp; events
    </p>
    <div class="all-mixed-grid">
      <app-posts [mixedItems]="postItems" [mixedMode]="true" [embedded]="true" [gridCols]="4"></app-posts>
      <app-blog [mixedItems]="blogItems" [mixedMode]="true" [embedded]="true" [gridCols]="4"></app-blog>
      <app-events [mixedItems]="eventItems" [mixedMode]="true" [embedded]="true" [gridCols]="4"></app-events>
    </div>

    <!-- Empty state -->
    <div *ngIf="isEmpty" class="flex flex-col items-center justify-center py-16 text-gray-400">
      <svg class="mb-3 h-10 w-10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M21 21L17.5001 17.5M20 11.5C20 16.1944 16.1944 20 11.5 20C6.80558 20 3 16.1944 3 11.5C3 6.80558 6.80558 3 11.5 3C16.1944 3 20 6.80558 20 11.5Z" />
      </svg>
      <p class="text-sm">No results found</p>
    </div>

    <!-- Loading spinner -->
    <div *ngIf="isLoading" class="flex items-center justify-center py-8">
      <div class="h-6 w-6 animate-spin rounded-full border-2 border-[#FFD4E0] border-t-[#D31148]"></div>
    </div>

    <!-- Infinite-scroll sentinel -->
    <div #scrollSentinel class="h-4"></div>

  </div>
</section>

<style>
  .all-mixed-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-auto-rows: 10px;
    gap: 0 20px;
  }

  @media (max-width: 1280px) {
    .all-mixed-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  @media (max-width: 900px) {
    .all-mixed-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 560px) {
    .all-mixed-grid {
      grid-template-columns: 1fr;
    }
  }
</style>

<app-scroll-to-top />
